// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_qGe","img":"styles_img__2Ytzc","left":"styles_left__3ZNJk","right":"styles_right__WGSf4"};